export const carouselImages = [
  {
    url: "https://lh3.googleusercontent.com/gps-cs-s/AHVAweq3ALWAQ5S628CeLTZGTCsSzubSU8DlH8oQ9qEpUZw1TBiFXXTr-tJc2xIn5bUp2fsNeEX3_L3rJYkyuYEQy0711WJUQznbIje_QNrcgcZ5hVPbeAD3JxWPhr5cTjMEf-rrbAQNUQ=s1360-w1360-h1020-rw",
    alt: "Veer Ji Restaurant Interior",
  },
  {
    url: "carouselImages/front-veerjichaapwale.jpg",
    alt: "Veer Ji Restaurant Exterior",
  },
  {
    url: "carouselImages/cusine-veerjichaapwale.webp",
    alt: "Signature Malai Chaap",
  },
  {
    url: "carouselImages/front21-veerjichaapwale.jpg",
    alt: "Veer Ji Restaurant Exterior",
  },
  {
    url: "carouselImages/cusine2-veerjichaapwale.webp",
    alt: "Signature Cusines",
  },
  {
    url: "carouselImages/cusine3-veerjichaapwale.webp",
    alt: "Signature Cusines",
  },
  {
    url: "carouselImages/cusine4-veerjichaapwale.webp",
    alt: "Signature Cusines",
  },
  {
    url: "carouselImages/cusine5-veerjichaapwale.webp",
    alt: "Signature Cusines",
  },
  {
    url: "carouselImages/cusine6-veerjichaapwale.webp",
    alt: "Signature Cusines",
  },
  {
    url: "carouselImages/cusine7-veerjichaapwale.webp",
    alt: "Signature Cusines",
  },
  {
    url: "carouselImages/cusine8-veerjichaapwale.webp",
    alt: "Signature Cusines",
  },
  {
    url: "carouselImages/k1.jpg",
    alt: "Signature Cusines",
  },
  {
    url: "carouselImages/k2.jpg",
    alt: "Signature Cusines",
  },
];